import React, { CSSProperties, useMemo } from 'react';
import styles from './Grid.module.scss';

export type GridProps = {
  children: React.ReactNode;
  columns: number;
  columnGap?: number;
  rowGap?: number;
  columnSizes?: CSSProperties['gridTemplateColumns'];
};

export default function Grid({
  children,
  columns,
  columnGap = 0,
  rowGap = 0,
  columnSizes,
}: GridProps) {
  const gridTemplateColumns = useMemo(() => (
    columnSizes || new Array(columns).fill('1fr').join(' ')
  ), [
    columnSizes,
    columns,
  ]);
  const style = {
    gridTemplateColumns,
    columnGap,
    rowGap,
  };

  return <div className={styles.grid} style={style}>{children}</div>;
}
